import { consumerClient } from "@/shared/services/apollo-clients/consumer-client";
import {
    GenericShopConfigDocument,
    GenericShopConfigQuery,
    GenericShopConfigQueryVariables,
} from "@/shared/services/graphql/generated/consumer-graph-types";

/**
 * True when the generic shop shows example data (demo mode): no shop URL is
 * configured, so the backend uses example data.
 * If the configuration cannot be read, this also returns true. Showing the demo
 * notice is safer than letting users take example data for real data.
 *
 * Why `consumerClient.query()` and not the generated `useGenericShopConfigLazyQuery()`:
 * outside a component the composable never cleans up after itself, and this
 * function runs on every tab switch (tech issue 0045).
 * Why `network-only`: the configuration must come from the server, not the cache,
 * so a change saved in the admin shows up at once (tech issue 0009, QIT-7029).
 */
export const loadIsGenericShopDemo = async (): Promise<boolean> => {
    try {
        const { data } = await consumerClient.query<GenericShopConfigQuery, GenericShopConfigQueryVariables>({
            query: GenericShopConfigDocument,
            fetchPolicy: "network-only",
        });
        // Copies the backend rule. Replace it when QIT-7334 lets the backend tell the
        // portal which shop system is used (tech issue 0051).
        return !data?.getGenericShopConfig?.graphqlUrl;
    } catch (error) {
        console.warn("Generic shop: configuration could not be read, showing demo mode.", error);
        return true;
    }
};
